import { styled as e, css as a } from "styled-components";
import { Button as s } from "../Button/index.js";
import { BodyHeavy as d } from "../../styles/typography/index.js";
import { Colors as t } from "../../styles/colors/index.js";
import { DarkNinjaThemeQuery as l, LightNinjaThemeQuery as p, Theme as r } from "../../styles/themes/index.js";
const o = e.span`
  display: block;
  position: absolute;
  height: 102%;
  z-index: 2;
  top: 0;
  right: 40px;
  width: 14px;
  background-color: rgb(${t.Tangerine});
  border-radius: 100% 0 0 100% / 50%;
  transform: rotate(-14deg) translateY(1px);
  transition: inherit;

  ${l} {
    background-color: rgb(${t.Bittersweet});
  }
  ${p} {
    background-color: rgb(${t.Gray});
  }
`, u = e.span``, n = e.span`
  transition: all 0.2s cubic-bezier(0.95, 0.05, 0.05, 0.95) 0s;
  display: inline-flex;
  align-items: center;
  z-index: 1;
  top: 0;
  right: 0;
  text-align: right;
  box-sizing: border-box;
  height: 100%;
  padding: 10px 0;
  position: absolute;
  width: 45px;
  border-radius: 0 18px 18px 0;
  overflow: hidden;
  margin-right: -1px;
  white-space: nowrap;
  background: rgb(${r.colors.Juliet});
  border: 1px solid rgb(${r.colors.Golf});
  border-left-width: 0;
  color: rgb(${r.colors.Alpha});
  ${d}

  &::after {
    content: attr(data-masked);
    width: 64px;
    position: absolute;
    right: 10px;
    direction: rtl;
  }

  &:hover:not(:disabled) {
    background: rgb(${r.colors.Juliet});
    color: rgb(${r.colors.Alpha});
  }
`, $ = e(s)`
  padding-right: ${({ responsive: i }) => i ? "0" : "66px"};
  transition: transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1.45) 0s;
  min-width: 240px;

  &:hover ${o} {
    background-color: rgb(${r.colors.Yankee});
    width: 24px;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    right: 40px;
    z-index: 2;
    width: 18px;
    height: 100%;
    background: inherit;
    transform: skew(14deg);
    transition: inherit;
    transition-property: width, transform;
  }

  &:disabled {
    transition: none;

    ${o} {
      background-color: rgb(${r.colors.Golf});
    }

    ${n} {
      color: rgb(${t.Gray});
    }
  }

  &:hover:not(:disabled) {
    ${o} {
      transform: rotate(-20deg) translateY(2px) translateX(-3px) scale(1.1);
      width: 14px;
    }

    &::before {
      transform: skew(18deg) translateX(-3px);
      width: 14px;
    }

    ${n} {
      width: 52px;
    }
  }

  ${(i) => i.inactive && a`
      ${o} {
        background-color: rgb(${t.Gray});
      }
      &:hover ${o} {
        background-color: rgb(${r.colors.Alpha});
      }
    `}
`;
export {
  $ as MaskedButtonContainer,
  o as MaskedButtonCorner,
  u as MaskedButtonCornerBend,
  n as MaskedButtonMaskedArea
};
